import React, { Component } from "react";
import { enqueueSnackbar } from "notistack";
import {SaveOutlined, InfoCircleOutlined, ArrowLeftOutlined, CheckCircleOutlined} from "@ant-design/icons";
import { Descriptions, Typography, Input, Select, Modal, Tooltip, Menu } from "antd";

const { Text } = Typography;
const { Option } = Select;
const AntSelect = Select;

class VoteMeetingCreate extends Component {
    state = {
        // Эмитент
        issuersData: null,
        issuerInput: "",
        selectedIssuer: null,
        address: "",
        issuerId: "",

        meetingId: null,
        MeetingName: '',
        MeetingLocation: '',
        DesicionDate: '',
        DeadlineDate: '',
        ProtocolDate: '',
        RecordDate: '',
        MeetingDate: '',
        CheckinTime: '',
        MeetingOpenTime: '',
        VoteCountingTime: '',
        AnnualOrUnscheduled: '',
        Status: '',
        EarlyRegistration: false,
        FirstOrRepeated: false,
        MeetingClose: '',
        Closeout: '',
        RegistrarId: '1',
        MeetingUrl: '',
        InterOrExtraMural: '',
        IssuerId: '',
        RegistrarName: 'Ведение реестров компаний',
        isButtonDisabled: true,
        showScrollUp: false,
    };

    async componentDidMount() {
        const { is_superuser } = this.props;
        if (!is_superuser) {
            alert("Доступ запрещен");
            window.location.href = `/#/`;
            return;
        }

        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

        try {
            const res = await fetch(`${API_ADDRESS}get_issuers/`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            if (res.status === 401) {
                alert("Время сессии истекло. Пожалуйста выполните вход.");
                document.getElementById("logoutBttn").click();
                return;
            }

            const data = await res.json();
            this.setState({ issuersData: data.issuers || [] });
        } catch (e) {
            console.error(e);
            enqueueSnackbar("Ошибка загрузки эмитентов", { variant: 'error' });
        }

        // Слушатель скролла для кнопки "Наверх"
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentDidUpdate(prevProps) {
        const { is_staff, is_superuser } = this.props;
        if (
            prevProps.is_staff !== is_staff ||
            prevProps.is_superuser !== is_superuser
        ) {
            if (!is_staff && !is_superuser) {
                alert("Доступ запрещен");
                window.location.href = `/#/`;
            }
        }
    }

    handleScroll = () => {
        if (this.scrollTimeout) clearTimeout(this.scrollTimeout);

        this.scrollTimeout = setTimeout(() => {
            const showScrollUp = window.scrollY > 130;
            this.setState({ showScrollUp });
        }, 50);
    };

    handleIssuerChange = (value, option) => {
        this.setState({
            selectedIssuer: value,
            issuerInput: value,
            address: option.address,
            issuerId: option.issuer_id,
            IssuerId: option.issuer_id,
        }, this.checkFieldsCompletion);
    };

    handleChange = (e) => {
        const { name, type, checked, value } = e.target;

        let newValue;
        if (type === 'checkbox') {
            newValue = checked;
        } else {
            newValue = value;

            // Только цифры для ID
            if (['IssuerId', 'RegistrarId'].includes(name)) {
                const originalValue = value;
                newValue = value.replace(/[^0-9]/g, '');
                if (originalValue !== newValue) {
                    enqueueSnackbar('Поле должно содержать только числа', { variant: 'error' });
                }
            }

            // Значения по умолчанию
            if (name === 'AnnualOrUnscheduled' && !value) newValue = '-';
            if (name === 'InterOrExtraMural' && !value) newValue = '-';
            if (name === 'Status' && !value) newValue = '-';
        }

        this.setState({ [name]: newValue }, this.checkFieldsCompletion);
    };

    checkFieldsCompletion = () => {
        const {
            MeetingName,
            MeetingDate,
            DesicionDate,
            ProtocolDate,
            DeadlineDate,
            CheckinTime,
            MeetingOpenTime,
            RecordDate
        } = this.state;

        const requiredFields = [
            MeetingName,
            MeetingDate,
            DesicionDate,
            ProtocolDate,
            DeadlineDate,
            CheckinTime,
            MeetingOpenTime,
            RecordDate
        ];

        const allFilled = requiredFields.every(field => field && field.trim() !== '' && field !== '-');

        this.setState({ isButtonDisabled: !allFilled });
    };

    handleSaveClick = async () => {
        const {
            MeetingName, MeetingLocation, DesicionDate, DeadlineDate, ProtocolDate,
            RecordDate, MeetingDate, CheckinTime, MeetingOpenTime, VoteCountingTime,
            AnnualOrUnscheduled, InterOrExtraMural, Status, EarlyRegistration, FirstOrRepeated,
            MeetingClose, Closeout, RegistrarId, MeetingUrl, IssuerId
        } = this.state;

        if (this.state.isButtonDisabled) {
            enqueueSnackbar('Заполните обязательные поля', { variant: 'error' });
            return;
        }

        const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;
        const data = {
            MeetingName,
            MeetingLocation,
            DesicionDate,
            DeadlineDate,
            ProtocolDate,
            RecordDate,
            MeetingDate,
            CheckinTime,
            MeetingOpenTime,
            VoteCountingTime,
            AnnualOrUnscheduled: AnnualOrUnscheduled === 'Годовое',
            InterOrExtraMural: InterOrExtraMural === 'Очное',
            Status,
            EarlyRegistration,
            FirstOrRepeated,
            MeetingClose,
            Closeout,
            RegistrarId,
            MeetingUrl,
            IssuerId
        };

        try {
            const response = await fetch(`${API_ADDRESS}save_meeting/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                const result = await response.json();
                const meetingId = result.meeting_id;

                this.setState({ meetingId }, () => {
                    Modal.confirm({
                        title: 'Собрание было создано',
                        content: (
                            <div>
                                Добавить для этого собрания вопросы и материалы ? <br /><br />
                                <i>Если сейчас не добавить вопросы или материалы, их всегда можно добавить через редактирование этого собрания в общем списке собраний.</i>
                            </div>
                        ),
                        okText: 'Да',
                        cancelText: 'Нет',
                        icon: <CheckCircleOutlined style={{ color: '#52c41a' }} />,
                        onOk: () => {
                            window.location.href = `/#/voteAgendaCreate/${meetingId}/`;
                        },
                        onCancel: () => {
                            window.location.href = `/#/voteMeetings/`;
                        },
                    });
                });
            } else {
                enqueueSnackbar('Ошибка сохранения', { variant: 'error' });
            }
        } catch (error) {
            enqueueSnackbar('Произошла сетевая ошибка', { variant: 'error' });
        }
    };

    handleBackClick = () => {
        window.location.href = `/#/`;
    };

    render() {
        const {
            MeetingName,
            MeetingLocation,
            DesicionDate,
            DeadlineDate,
            ProtocolDate,
            RecordDate,
            MeetingDate,
            CheckinTime,
            MeetingOpenTime,
            VoteCountingTime,
            AnnualOrUnscheduled,
            InterOrExtraMural,
            Status,
            EarlyRegistration,
            FirstOrRepeated,
            MeetingClose,
            Closeout,
            RegistrarId,
            MeetingUrl,
            address,
            issuerId,
            issuerInput,
            issuersData,
            isButtonDisabled,
            showScrollUp
        } = this.state;

        // Список обязательных полей по ключам
        const requiredFields = [
            'issuer',
            'decisionDate',
            'protocolDate',
            'recordDate',
            'meetingDate',
            'deadlineDate',
            'checkin',
            'meetingOpen',
            'meetingName',
        ];

        // Функция для отображения label с *
        const renderLabel = (text, key) => (
            <span>
                {text}
                {requiredFields.includes(key) && (
                    <span style={{ color: 'red', marginLeft: 4 }}>*</span>
                )}
            </span>
        );

        const options = (issuersData || []).map((issuer) => ({
            value: issuer.full_name,
            label: issuer.full_name,
            address: issuer.address,
            issuer_id: issuer.issuer_id,
        }));

        return (
            <>
                <div className="page-container">
                    <div className="vmr-container">
                        {/* Заголовок */}
                        <div className="vmr-header" style={{alignItems: 'flex-start', gap: '12px'}}>
                            <div className="back-button-wrapper" onClick={this.handleBackClick}>
                                <ArrowLeftOutlined
                                    style={{fontSize: '20px', cursor: 'pointer', marginTop: '4px'}}
                                />
                            </div>
                            <h1 className="vmr-header-title" style={{margin: 0}}>
                                Создание нового собрания
                            </h1>
                        </div>

                        <div className="vmr-main-layout">
                            <div className="vmr-sidebar-container">
                                <Menu
                                    mode="inline"
                                    style={{
                                        border: '1px solid #ccc',
                                        borderRadius: '8px',
                                        backgroundColor: '#fff',
                                    }}
                                    selectedKeys={[]}
                                >
                                    {(() => {
                                        const saveButton = (
                                            <Menu.Item
                                                key="save"
                                                icon={<SaveOutlined/>}
                                                className="menu-item-color"
                                                style={{paddingLeft: '15px'}}
                                                onClick={this.handleSaveClick}
                                                disabled={isButtonDisabled}
                                            >
                                                Сохранить
                                            </Menu.Item>
                                        );

                                        return isButtonDisabled ? (
                                            <Tooltip
                                                title="Для создания собрания необходимо заполнить обязательные поля, они помечены звездочкой (*)"
                                                placement="bottom"
                                            >
                                                {saveButton}
                                            </Tooltip>
                                        ) : (
                                            saveButton
                                        );
                                    })()}
                                </Menu>
                            </div>

                            <div className="vmr-form">
                                <Descriptions
                                    bordered
                                    column={2}
                                    size="middle"
                                    items={[
                                        {
                                            key: 'issuer',
                                            label: renderLabel('Эмитент', 'issuer'),
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <AntSelect
                                                    showSearch
                                                    value={issuerInput}
                                                    onSelect={this.handleIssuerChange}
                                                    options={options}
                                                    placeholder="Выберите эмитента"
                                                    style={{width: '100%'}}
                                                    optionFilterProp="label"
                                                />
                                            ),
                                            span: 2,
                                        },
                                        {
                                            key: 'address',
                                            label: 'Место нахождения',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Text strong style={{color: address ? 'inherit' : '#999'}}>
                                                    {address || (
                                                        <span style={{fontStyle: 'italic'}}>
                                                        Заполняется автоматически
                                                    </span>
                                                    )}
                                                </Text>
                                            ),
                                            span: 2,
                                        },
                                        {
                                            key: 'issuerId',
                                            label: 'Код эмитента',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Text strong style={{color: issuerId ? 'inherit' : '#999'}}>
                                                    {issuerId || (
                                                        <span style={{fontStyle: 'italic'}}>
                                                        Заполняется автоматически
                                                    </span>
                                                    )}
                                                </Text>
                                            ),
                                            span: 1,
                                        },
                                        {
                                            key: 'registrarId',
                                            label: 'Код регистратора',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: <Text strong>{RegistrarId}</Text>,
                                            span: 1,
                                        },
                                        {
                                            key: 'registrar',
                                            label: 'Регистратор',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: <Text strong>{this.state.RegistrarName}</Text>,
                                            span: 2,
                                        },
                                        {
                                            key: 'meetingName',
                                            label: renderLabel('Описание собрания', 'meetingName'),
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    name="MeetingName"
                                                    value={MeetingName}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                            span: 2,
                                        },
                                        {
                                            key: 'meetingLocation',
                                            label: 'Место проведения / Почтовый адрес',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    name="MeetingLocation"
                                                    value={MeetingLocation}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                            span: 2,
                                        },
                                        {
                                            key: 'meetingUrl',
                                            label: 'Ссылка на трансляцию',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    name="MeetingUrl"
                                                    value={MeetingUrl}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                            span: 1,
                                        },
                                        {
                                            key: 'decisionDate',
                                            label: renderLabel('Дата принятия решения', 'decisionDate'),
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="DesicionDate"
                                                    value={DesicionDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'deadlineDate',
                                            label: renderLabel('Дата окончания приёма', 'deadlineDate'),
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="DeadlineDate"
                                                    value={DeadlineDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'protocolDate',
                                            label: renderLabel('Дата составления протокола', 'protocolDate'),
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="ProtocolDate"
                                                    value={ProtocolDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'recordDate',
                                            label: renderLabel('Дата составления списка', 'recordDate'),
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="RecordDate"
                                                    value={RecordDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'meetingDate',
                                            label: renderLabel('Дата собрания', 'meetingDate'),
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="date"
                                                    name="MeetingDate"
                                                    value={MeetingDate}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'checkin',
                                            label: renderLabel('Начало регистрации', 'checkin'),
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="CheckinTime"
                                                    value={CheckinTime}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'closeout',
                                            label: 'Окончание регистрации',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="Closeout"
                                                    value={Closeout}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'meetingOpen',
                                            label: renderLabel('Начало собрания', 'meetingOpen'),
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="MeetingOpenTime"
                                                    value={MeetingOpenTime}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'meetingClose',
                                            label: 'Окончание собрания',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="MeetingClose"
                                                    value={MeetingClose}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'voteCounting',
                                            label: 'Начало подсчёта голосов',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <Input
                                                    type="datetime-local"
                                                    name="VoteCountingTime"
                                                    value={VoteCountingTime}
                                                    onChange={this.handleChange}
                                                />
                                            ),
                                        },
                                        // Остальные поля — не обязательные
                                        {
                                            key: 'annualOrUnscheduled',
                                            label: 'Вид собрания',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <AntSelect
                                                    name="AnnualOrUnscheduled"
                                                    value={AnnualOrUnscheduled}
                                                    onChange={(value) => this.setState({AnnualOrUnscheduled: value})}
                                                    style={{width: '100%'}}
                                                >
                                                    <Option value="Годовое">Годовое</Option>
                                                    <Option value="Внеочередное">Внеочередное</Option>
                                                    <Option value="Годовое повторное">Годовое повторное</Option>
                                                    <Option value="Внеочередное повторное">Внеочередное
                                                        повторное</Option>
                                                </AntSelect>
                                            ),
                                        },
                                        {
                                            key: 'firstOrRepeated',
                                            label: 'Повторное собрание',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <input
                                                    type="checkbox"
                                                    name="FirstOrRepeated"
                                                    checked={FirstOrRepeated}
                                                    onChange={this.handleChange}
                                                    style={{transform: 'scale(1.2)'}}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'status',
                                            label: 'Статус',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <AntSelect
                                                    name="Status"
                                                    value={Status}
                                                    onChange={(value) => this.setState({Status: value})}
                                                    style={{width: '100%'}}
                                                >
                                                    <Option value="Ожидается">Ожидается</Option>
                                                    <Option value="Разрешена регистрация">Разрешена регистрация</Option>
                                                    <Option value="Разрешено голосование">Разрешено голосование</Option>
                                                    <Option value="Голосование завершено">Голосование завершено</Option>
                                                    <Option value="Собрание завершилось">Собрание завершилось</Option>
                                                </AntSelect>
                                            ),
                                        },
                                        {
                                            key: 'earlyRegistration',
                                            label: 'Досрочная регистрация',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <input
                                                    type="checkbox"
                                                    name="EarlyRegistration"
                                                    checked={EarlyRegistration}
                                                    onChange={this.handleChange}
                                                    style={{transform: 'scale(1.2)'}}
                                                />
                                            ),
                                        },
                                        {
                                            key: 'interOrExtraMural',
                                            label: 'Форма собрания',
                                            labelStyle: {fontWeight: 'bold'},
                                            children: (
                                                <AntSelect
                                                    name="InterOrExtraMural"
                                                    value={InterOrExtraMural}
                                                    onChange={(value) => this.setState({InterOrExtraMural: value})}
                                                    style={{width: '100%'}}
                                                >
                                                    <Option value="Очное">Очное</Option>
                                                    <Option value="Заочное">Заочное</Option>
                                                </AntSelect>
                                            ),
                                        },
                                    ]}
                                    className="custom-descriptions"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default VoteMeetingCreate;